"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sequence = void 0;
var consonants = /[\u{05D0}-\u{05F2}]/u;
var ligature = /[\u{05C1}-\u{05C2}]/u;
var dagesh = /[\u{05BC},\u{05BF}]/u; // includes rafe
var vowels = /[\u{05B0}-\u{05BB},\u{05C7}]/u;
var accents = /[\u{0590}-\u{05AF},\u{05BD}-\u{05BE},\u{05C0},\u{05C3}]/u;
var Char = /** @class */ (function () {
    function Char(char) {
        this.char = char;
        this.posIndex = this.findPos(this.char);
    }
    Char.prototype.findPos = function (char) {
        if (consonants.test(char)) {
            return 0;
        }
        if (ligature.test(char)) {
            return 1;
        }
        if (dagesh.test(char)) {
            return 2;
        }
        if (vowels.test(char)) {
            return 3;
        }
        if (accents.test(char)) {
            return 4;
        }
        return 10;
    };
    return Char;
}());
exports.Sequence = function (text) {
    var splits = /(?=[\u{05D0}-\u{05F2}])/u;
    var charClusters = text.split(splits);
    var mapClusters = charClusters.map(function (cluster) { return __spread(cluster).map(function (char) { return new Char(char); }); });
    var sortClusters = mapClusters.map(function (cluster) { return cluster.sort(function (a, b) { return a.posIndex - b.posIndex; }); });
    var redClusters = sortClusters.map(function (cluster) { return cluster.reduce(function (a, c) { return a + c.char; }, ""); });
    var seqText = redClusters.reduce(function (a, c) { return a + c; });
    return seqText;
};
//# sourceMappingURL=sequence.js.map